import * as React from "react";
import {
    ButtonTextPrimary,
    SecondaryActionButton,
} from "./PostActionButtons.styles";
import { Stack } from "@mui/material";
import { LocationDotSolidIcon } from "@icons/LocationDotSolidIcon";
import { TEXT_ELLIPSIS } from "../../../Shared/styles";

export function LocationButton({
    location,
    textColor,
    backgroundColor,
    rightIconColor,
}: {
    location: string;
    backgroundColor?: string;
    rightIconColor?: string;
    textColor?: string;
}) {
    return (
        <>
            <SecondaryActionButton
                disableRipple
                style={{ backgroundColor: backgroundColor }}
            >
                <Stack
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        width: "40px",
                    }}
                >
                    <LocationDotSolidIcon
                        color={
                            rightIconColor ||
                            "var(--community-color-light-steal-blue)"
                        }
                        width="16px"
                        height="16px"
                    />
                </Stack>
                <Stack
                    flex="1"
                    alignItems="flex-start"
                    sx={{ minWidth: 0, ...TEXT_ELLIPSIS }}
                >
                    <ButtonTextPrimary
                        style={{
                            color:
                                textColor ||
                                "var(--community-color-light-steal-blue)",
                        }}
                    >
                        {location}
                    </ButtonTextPrimary>
                </Stack>
            </SecondaryActionButton>
        </>
    );
}
